/**
 * Returns the path of the current or given URL.
 *
 * @param {string} [rawUrl=window.location.href]
 * @returns {string}
 */
export function serverPath(rawUrl = window.location.href) {
    const url = new URL(rawUrl);
    return url.pathname;
}
